import { Button } from "component-library";
import { useTranslation } from "i18n";
import { useHistory } from "react-router-dom";
import applicationMap from "services/applicationMap";

const TransferToGrads = ({ enabled }: { enabled?: boolean }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const buttonType = enabled ? "secondary" : "primary";

  return (
    <div className="mb-6 flex w-full flex-col gap-3 lg:w-[80%]">
      <div>
        <h3 className="text-xxl">
          {t(
            "performer:accountSettings.mySubscriptionPage.transferToGrad.title"
          )}
        </h3>
      </div>
      <span className="whitespace-pre-line">
        {t(
          "performer:accountSettings.mySubscriptionPage.transferToGrad.description"
        )}
      </span>
      <Button
        type={buttonType}
        text={t(
          "performer:accountSettings.mySubscriptionPage.transferToGrad.buttonTitle"
        )}
        className="w-fit"
        disabled={!enabled}
        size="small"
        onClick={() =>
          history.push(applicationMap.routes.graduatesTransferInformation())
        }
      />
    </div>
  );
};

export default TransferToGrads;
